// import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoService } from '../services/seo/seo.service';
import { SharedService } from '../services';
import { catchError, of, take } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { identity, map, pickBy } from 'lodash';

@Component({
  template: '',
})
export class BaseNotFoundComponent {
  seo: any;
  posId: string = '';
  constructor(
    protected renderer: Renderer2,
    protected metaTagService: Meta,
    protected titleTagService: Title,
    protected seoService: SeoService,
    protected sharedService: SharedService,
    @Inject(DOCUMENT) protected document: Document,
    @Inject(PLATFORM_ID) protected platformId: Object,
  ) {
    this.sharedService.posId$.subscribe((posId) => {
      this.posId = posId;
    });
    this.seoService
    .getGeneralSEOJSON()
    .pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    )
    .subscribe((res) => {
      this.seo = res;
      if (this.seo?.title) {
        this.titleTagService.setTitle(this.seo?.title);
      }
      this.sharedService.tags$ = [
        ...this.metaTagService.addTags(map(this.seo?.metas, (meta) => pickBy(meta, identity))),
        { charset: 'UTF-8' },
      ];
        this.sharedService.links$ = map(this.seo?.links, (seoLink) => {
          const link = this.renderer.createElement('link');
          if (seoLink.sizes) {
            link.sizes = seoLink.sizes;
          }
          if (seoLink.href) {
            link.href = seoLink.href;
          }
          if (seoLink.rel) {
            link.rel = seoLink.rel;
          }
          this.renderer.appendChild(this.document.head, link);
          return link;
        });
    });
  }
}
